import OrchestratorAPI from './common.js';
import {
  type CreateValues,
  type EhrInstanceAlert,
  type EhrInstanceAlertHistory,
  type FindAllOptions,
  type UpdateValues,
} from '../models/orchestrator/ehrInstanceAlert.js';

const dateFields: (keyof EhrInstanceAlert)[] = ['created', 'updated', 'deleted'];

const historyDateFields: (keyof EhrInstanceAlertHistory)[] = [
  'created',
  'updated',
  'alertPreferenceDeleted',
  'alertPreferenceCreated',
];

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/alert-preferences';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async create(values: CreateValues): Promise<EhrInstanceAlert> {
    const url = this.constructPath('/');
    const { alertPreference } = await this.common.postJSON(url, values);
    return this.deserialize(alertPreference, { dateFields });
  }

  async delete(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return await this.common.deleteJSON(url);
  }

  async findAll(options?: FindAllOptions): Promise<EhrInstanceAlert[]> {
    const url = this.constructPath('/', options);
    const { alertPreferences } = await this.common.getJSON(url);
    return alertPreferences.map((preference: any) => this.deserialize(preference, { dateFields }));
  }

  async findOneById(id: string): Promise<EhrInstanceAlert> {
    const url = this.constructPath(`/${id}`);
    const { alertPreference } = await this.common.getJSON(url);
    return this.deserialize(alertPreference, { dateFields });
  }

  async findHistory(alertPreferenceId: string): Promise<EhrInstanceAlertHistory[]> {
    const url = this.constructPath(`/${alertPreferenceId}/history`);
    const { alertPreferenceHistory } = await this.common.getJSON(url);
    return alertPreferenceHistory.map((preference: any) =>
      this.deserialize(preference, {
        dateFields: historyDateFields,
      })
    );
  }

  async update(id: string, values: UpdateValues): Promise<EhrInstanceAlert> {
    const url = this.constructPath(`/${id}`);
    const { alertPreference } = await this.common.patchJSON(url, values);
    return this.deserialize(alertPreference, { dateFields });
  }
}
